// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__m16nj","controls":"styles_controls__mVlb2","charLimit":"styles_charLimit__35JO-","input":"styles_input__2dF1i","send":"styles_send__3jICg"};